export class HsmLinkSearchResult {
    bookWrapper: { id: number; title: string; coverPath: string; prefix: string };
    hsmLinks: Array<{
        active: string;
        page_id: number;
        text: string;
    }>;

    constructor() {
        this.hsmLinks = [];
    }
}
